import { cn } from '../lib/cn';

export const dropdownMenuStyles = {
  content: cn(
    'z-dropdown min-w-[12rem] overflow-hidden rounded-md border border-border-subtle',
    'bg-bg-canvas text-fg-primary shadow-e3 p-1',
    'origin-[var(--radix-dropdown-menu-content-transform-origin)]',
    'transition duration-fast ease-token',
    'data-[state=closed]:opacity-0 data-[state=closed]:scale-95',
    'data-[state=open]:opacity-100 data-[state=open]:scale-100',
  ),
  item: cn(
    'relative flex cursor-pointer select-none items-center gap-2 rounded-sm px-2 py-2 text-sm outline-none',
    'transition-colors duration-fast ease-token',
    'focus:bg-bg-subtle focus:text-fg-primary',
    'data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
  ),
  itemInset: 'pl-8',
  checkboxItem: cn(
    'relative flex cursor-pointer select-none items-center rounded-sm py-2 pl-8 pr-2 text-sm outline-none',
    'transition-colors duration-fast ease-token',
    'focus:bg-bg-subtle focus:text-fg-primary',
    'data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
  ),
  radioItem: cn(
    'relative flex cursor-pointer select-none items-center rounded-sm py-2 pl-8 pr-2 text-sm outline-none',
    'transition-colors duration-fast ease-token',
    'focus:bg-bg-subtle focus:text-fg-primary',
    'data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
  ),
  indicatorSlot: 'absolute left-2 flex h-4 w-4 items-center justify-center',
  checkIcon: 'h-4 w-4',
  radioDot: 'bg-accent h-2 w-2 rounded-full',
  label: 'px-2 py-1.5 text-xs font-medium uppercase tracking-wide text-fg-muted',
  labelInset: 'pl-8',
  separator: '-mx-1 my-1 h-px bg-border-subtle',
  shortcut: 'ml-auto text-xs tracking-widest text-fg-muted',
} as const;
